import { Map } from 'immutable';

export const initialState = Map({});

export const getter = (): string => 'function';
